// The operators drawer (Brief 5) — the right-side roster the user watches:
// Supervisor (Guard), Engineering / Design / Product (the three domain
// Arbiters), Signal (Signal). Neutral at rest; each operator's most recent
// line in this session is its "last seen"; Signal carries the one amber
// "needs you" while a brain question is pending. Reads only data already in
// the channel (the messages) — no new subscription.

import type { ChatMessage } from "@waytide/core";
import { OPERATORS, baseOperatorKind } from "../model/operators";

const ROSTER = ["supervisor", "engineering", "design", "product", "signal"] as const;

/** The most recent message body from `operatorId` in this session, or null. */
export function lastFromOperator(
  messages: ChatMessage[],
  operatorId: string,
): string | null {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (baseOperatorKind(messages[i].sender_kind) === operatorId) {
      return messages[i].body;
    }
  }
  return null;
}

export function OperatorsDrawer({
  messages,
  pending,
}: {
  messages: ChatMessage[];
  pending: boolean;
}) {
  return (
    <aside className="wt-ops" aria-label="Operators">
      <div className="wt-ops__head">Operators</div>
      {ROSTER.map((id) => {
        const op = OPERATORS[id];
        const needsYou = id === "signal" && pending;
        const last = lastFromOperator(messages, id);
        return (
          <div
            key={id}
            className={`wt-ops__row${needsYou ? " wt-ops__row--needs" : ""}`}
            data-operator={id}
          >
            <span className={`wt-ops__name ${op.accentClass}`}>{op.name}</span>
            <span className="wt-ops__role">{op.role}</span>
            <span className="wt-ops__last">
              {needsYou ? "Needs you" : (last ?? "Watching")}
            </span>
          </div>
        );
      })}
    </aside>
  );
}
